import {useState, useEffect} from 'react'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import PaginationLayout from '../Assessment/PaginationLayout'
import {useNavigate} from 'react-router-dom'
import InformationLayout from '../Assessment/Information'
import TabStatusLayout from '../Assessment/TabStatusLayout'
import LawModal from '../Assessment/LawModal'
import LetterModal from '../Assessment/LetterModal'
import BadgeCategory from '../Assessment/BadgeCategory'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import usePagination from 'utils/hooks/usePagination'
import {clearLocalStorageExcept, getGreeting} from 'thesis-and-dissertations/helpers/helper'
import {toast} from 'react-toastify'
import '../Assessment/style.css'
import DropdownStatus from './DropdownStatus'
import StatusButton from './StatusButton'
import SortableHeaders from './SortableHeaders'
import RangeDate from './RangeDate'

const api = new Api()

const VerifierHomePage = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })

  const [showLetterModal, setShowLetterModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [asAgree, setAsAgree] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc', role: 'verifikator'})

  const [data, setData] = useState<any>({})
  const [user, setUser] = useState<any>({})
  const [currentLetter, setCurrentLetter] = useState({title: '', buttonText: ''})
  const [buttonExtra, setButtonExtra] = useState<any>([
    {
      name: 'Export Excel',
      color: '#F95E2F',
      key: 'Export Excel',
      icon: 'fa fa-file-excel',
    },
  ])

  const [sorting, setSorting] = useState({
    sort_field: '',
    sort_order: '', // 'asc' atau 'desc'
  })

  const paginator: any = usePagination({
    totalCount: data?.list?.total || 0,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  useEffect(() => {
    fetchIntegrityFacts()
    setUser(JSON.parse(localStorage?.getItem('kt-auth-react-v') || ''))
  }, [])

  useEffect(() => {
    setQuery({
      ...query,
      sort_field: sorting.sort_field,
      sort_order: sorting.sort_order,
    })
  }, [sorting])

  useEffect(() => {
    fetchData()
  }, [query, pagination.per_page, pagination.page])

  const onChangePerPage = (data: any) => {
    setPagination(data)
  }

  const handleCloseModal = (action: boolean) => {
    setAsAgree(action)
    if (action === false) {
      setShowLetterModal(true)
      handleCurrentLetter('Pakta Integritas', 'Saya Setuju', true)
    }
  }

  const handleCloseLetterModal = (action: boolean) => {
    setAsAgree(action)
    handleCurrentLetter('', '', false)
  }

  const fetchData = () => {
    setLoading(true)
    api
      .getListRegistrationPana({
        ...query,
        page: pagination.page,
        per_page: pagination.per_page,
      })
      .then((response: any) => {
        const {data} = response.data
        setData(data)
        setLoading(false)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error?.response
        toast.error(data?.message ?? data?.meta?.message)

        if (status == 401) {
          clearLocalStorageExcept()
          window.location.reload()
        }
      })
  }

  const fetchIntegrityFacts = () => {
    setLoading(true)
    api
      .getIntegrityFacts()
      .then((response: any) => {
        const {data} = response.data
        setAsAgree(data?.status === false ? true : false)
        setLoading(false)
      })
      .catch((error: any) => {
        setLoading(false)
      })
  }

  const handleCurrentLetter = (letter: string, buttonText: string, isShow: boolean) => {
    setCurrentLetter({
      title: letter,
      buttonText: buttonText,
    })

    setShowLetterModal(isShow)
  }

  const handleCurrentTab = (status: any) => {
    setQuery({status_tab: status})

    setPagination({
      ...pagination,
      per_page: 10,
      page: 1,
    })
  }

  const handleSorting = (sort_field: any) => {
    setSorting((prev) => {
      const isSameKey = prev.sort_field === sort_field
      const newOrder = isSameKey && prev.sort_order === 'asc' ? 'desc' : 'asc'
      return {sort_field, sort_order: newOrder}
    })
  }

  const handleInput = (name: string, e: any) => {
    setPagination({...pagination, per_page: pagination.per_page, page: 1})
    setQuery((prev: any) => ({
      ...prev,
      [name]: e?.target?.value !== undefined ? e.target.value : e,
    }))
  }

  return (
    <div>
      <LawModal showModal={asAgree} handleCloseModal={handleCloseModal} />
      <LetterModal
        showLetterModal={showLetterModal}
        handleCloseLetterModal={handleCloseLetterModal}
        currentLetter={currentLetter}
        currentPage='verifikator'
      />

      <div style={{marginTop: '-15px'}}>
        <p className='display-6 fw-normal'>
          {getGreeting()}, {user?.users_firstname}
        </p>
        <p>Berikut adalah daftar peserta yang perlu dinilai hari ini</p>
      </div>

      <InformationLayout />

      <TabStatusLayout
        data={[
          {
            name: 'Semua',
            key: '',
            value: data?.count?.all,
          },
          {
            name: 'Belum Penilaian',
            key: 'belum_dinilai',
            value: data?.count?.belum_penilaian,
          },
          {
            name: 'Diterima',
            key: 'lolos',
            value: data?.count?.diterima,
          },
          {
            name: 'Ditolak',
            key: 'tidak_lolos',
            value: data?.count?.ditolak,
          },
        ]}
        currentLetter={currentLetter}
        handleCurrentLetter={handleCurrentLetter}
        handleCurrentTab={handleCurrentTab}
        buttons={buttonExtra}
        disabledTab={true}
      />

      <div className='mt-4'>
        <div className='table-responsive'>
          <table className='table table-borderless align-middle'>
            <thead className='bg-white'>
              <tr>
                <th className='bg-light'>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Cari Nama'
                    onChange={(e) => handleInput('q', e)}
                  />
                </th>

                <th className='bg-light'>
                  <select className='form-control' onChange={(e) => handleInput('kategori', e)}>
                    <option value=''>--Pilih Kategori--</option>
                    <option value='individu'>Individu</option>
                    <option value='kelompok'>Kelompok</option>
                  </select>
                </th>

                <th className='bg-light'>
                  <RangeDate onSelectedDate={handleInput} />
                </th>

                <th className='bg-light'>
                  <DropdownStatus handleSelectStatus={handleInput} />
                </th>
              </tr>
              <tr>
                <SortableHeaders
                  label='Nama'
                  field='nama_pendaftar'
                  handleSorting={handleSorting}
                  sorting={sorting}
                />
                <SortableHeaders
                  label='KATEGORI'
                  field='kategori'
                  handleSorting={handleSorting}
                  sorting={sorting}
                />
                <SortableHeaders
                  label='WAKTU PENDAFTARAN'
                  field='waktu_pendaftaran'
                  handleSorting={handleSorting}
                  sorting={sorting}
                />
                <th className='py-5'>STATUS ADMINISTRASI</th>
                <th className='py-5'>AKSI</th>
              </tr>
            </thead>
            <tbody>
              {data?.list?.data?.length > 0 ? (
                data?.list?.data.map((item: any, index: any) => (
                  <>
                    <tr key={`spacer-${index}`}>
                      <td colSpan={5} style={{height: '16px', backgroundColor: 'transparent'}}></td>
                    </tr>
                    <tr key={item.id} className='bg-white'>
                      <td style={{borderTopLeftRadius: '20px', borderBottomLeftRadius: '20px'}}>
                        <div className='d-flex align-items-center p-5'>
                          <div
                            className='rounded-circle bg-secondary d-flex justify-content-center align-items-center'
                            style={{width: '40px', height: '40px'}}
                          >
                            <i className='fa fa-user'></i>
                          </div>
                          <div className='ms-3'>
                            <div className='fw-semibold'>{item?.nama_pendaftar}</div>
                            <div className='text-muted' style={{fontSize: '0.85rem'}}>
                              {item?.no_registrasi_pendaftaran}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <BadgeCategory
                          text={item?.kategori === 'kelompok' ? 'Kelompok' : 'Individu'}
                          textColor={item?.kategori === 'kelompok' ? '#1E40AF' : '#1E40AF'}
                          bgColor={item?.kategori === 'kelompok' ? '#DBEAFE' : '#FFDFFF'}
                        />
                      </td>
                      <td>{item?.waktu_pendaftaran}</td>
                      <td>
                        <StatusButton
                          status={item?.status_administrasi}
                          statusColor={item?.status_color}
                        />
                      </td>
                      <td style={{borderTopRightRadius: '20px', borderBottomRightRadius: '20px'}}>
                        <div className='d-flex align-items-center'>
                          <button
                            onClick={() => navigate(`/proposal/${item?.id_assignment}`)}
                            className='btn btn-sm text-white px-3 btn-primary me-2'
                          >
                            <i className='fa fa-edit me-1'></i>PENILAIAN
                          </button>
                        </div>
                      </td>
                    </tr>
                  </>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className='text-center py-5'>
                    <div className='text-muted'>
                      <i className='fa fa-folder-open fa-2x mb-2'></i>
                      <div>Tidak ada data</div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className='px-1'>
        <PaginationLayout
          paginate={pagination}
          paginator={paginator}
          onChangePerPage={onChangePerPage}
          totalData={data?.list?.data?.length}
        />
      </div>
    </div>
  )
}

const VerifierHome = () => {
  return (
    <>
      <VerifierHomePage />
    </>
  )
}

export default VerifierHome
